const hostOf = (url: unknown): string => {
  if (typeof url !== 'string' || !url) return '';
  try {
    return new URL(url).host;
  } catch {
    return url;
  }
};

export { hostOf };
